import { apiGet } from '../../../shared/api-client/index.js';

export type MemoryLevel = 'l1' | 'l2' | 'l3';

export interface MemoryRecordDto {
  id: string;
  level: MemoryLevel;
  key: string;
  valueText: string;
  importance: number;
  metadata?: Record<string, unknown> | null;
  createdAt: string;
}

export interface ListRecentMemoriesResponse {
  scope: 'deal' | 'contact' | 'workspace';
  count: number;
  items: MemoryRecordDto[];
}

export interface SearchL3MemoriesResponse {
  query: string;
  count: number;
  items: Array<MemoryRecordDto & { score: number }>;
}

export async function listRecentMemories(level: MemoryLevel, limit = 20): Promise<ListRecentMemoriesResponse> {
  const params = new URLSearchParams({
    scope: 'workspace',
    level,
    limit: String(limit),
  });
  return apiGet<ListRecentMemoriesResponse>(`/memory/recent?${params.toString()}`);
}

export async function searchL3Memories(query: string, limit = 10): Promise<SearchL3MemoriesResponse> {
  const params = new URLSearchParams({
    q: query,
    limit: String(limit),
  });
  return apiGet<SearchL3MemoriesResponse>(`/memory/search?${params.toString()}`);
}
